// Stock voices available for selection across the application
export const stockVoices = [
  {
    id: 'KTPVrSVAEUSJRClDzBw7',
    name: 'Cowboy Bob - VF',
    description: 'Rich voice with rugged warmth, perfect for tales filled with character.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/KTPVrSVAEUSJRClDzBw7/eDJs6fCZztHhoI1rMibZ.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'male'
  },
  {
    id: 'lUCNYQh2kqW2wiie85Qk',
    name: 'Charmion - Soft',
    description: 'Middle-aged British female. Suitable for Characters.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/RimHwwF9RLXKyDFWJaBLpWiGSr93/voices/lUCNYQh2kqW2wiie85Qk/89c6cfb4-9665-46c2-b665-037be403172b.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'female'
  },
  {
    id: 'ejl43bbp2vjkAFGSmAMa',
    name: 'Veronica - Sassy & Energetic',
    description: 'A young American voice that is energetic and slightly raspy. Her tone is spunky and full of sass, perfect for animated characters, sidekicks or even villains.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/2c44lnsQOsfR8eqztNjVaewaXRe2/voices/ejl43bbp2vjkAFGSmAMa/femJsdLGQZNrFtjTT9SK.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'female'
  },
  {
    id: 'bwCXcoVxWNYMlC6Esa8u',
    name: 'Matthew Schmitz - Anti-Hero, Villain, Rogue, Tough Guy',
    description: 'A deep, commanding voice with cinematic gravitas - rich, resonant, and powerful. It carries mystery and authority, sculpted with precision, like a dark guardian emerging from the shadows, unforgettable and bold. Perfect for an evil villain or rugged anti-hero. Voiced by Matthew Schmitz, a professional audiobook narrator with a large fan-base.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/Ebw6aIoLNBYbnP45ZSB5aHxmIAo2/voices/bwCXcoVxWNYMlC6Esa8u/7oTdXcBZTt2vzYio8oCo.mp3',
    isNarrator: false,
    category: 'Villains',
    gender: 'male'
  },
  {
    id: 'B52raBK48m23qWYbwchQ',
    name: 'Matthew Schmitz - Old Storyteller',
    description: 'An old grizzled Storyteller, rich resonant depth, exuding warmth. It has a commanding yet soothing presence, making it perfect for storytelling, with each word delivered clearly and purposefully. The pacing is measured yet engaging, drawing the listener in effortlessly. This is a voice that lingers, leaving a lasting impression long after the story ends. Voiced by Matthew Schmitz, a professional audiobook narrator, who has a large fan-base.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/Ebw6aIoLNBYbnP45ZSB5aHxmIAo2/voices/B52raBK48m23qWYbwchQ/QL4PaNGrtddJMg9K8F8I.mp3',
    isNarrator: false,
    category: 'Narrators',
    gender: 'male'
  },
  {
    id: 'WUyjxM8OTY6l8LhTmdkq',
    name: 'Folly Willowmere - Moonlight Fairy & Forrest Guardian',
    description: 'Whispery, gentle voice with childlike wonder and gentle wisdom. Speaks in fragmented patterns with thoughtful pauses, treating all objects as living friends. Perfect for magical storytelling and nature-inspired content.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/JkMtMybti7dSnGjkDsVqAkUgccE3/voices/WUyjxM8OTY6l8LhTmdkq/kdO4W62QH0XiNoaJ3qvu.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'female'
  },
  {
    id: 'esy0r39YPLQjOczyOib8',
    name: 'Brittney - Female Villain, Wicked and Deliciously Dark',
    description: 'A calm and calculating female villain. The perfect character for your epic novel, dark animation, or fantasy film. She is mischievous, clever, cunning, and deliciously dark. Though sarcastic at times, she is dangerously smart and outwits her enemies easily. A wicked addition to your script!',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/glklRmLoFeWZciiTRthKn6JAIwp1/voices/esy0r39YPLQjOczyOib8/HTHkPiNlxYETEllpEhuJ.mp3',
    isNarrator: false,
    category: 'Villains',
    gender: 'female'
  },
  {
    id: 'U1Vk2oyatMdYs096Ety7',
    name: 'Michael',
    description: 'A deep and controlled British urban voice.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/U1Vk2oyatMdYs096Ety7/B0gUarTYOGvFkIkTmcJd.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'male'
  },
  {
    id: 'uVKHymY7OYMd6OailpG5',
    name: 'Frederick - Old Gnarly Narrator',
    description: 'Listen to the rugged tales, this grizzled baritone tells. This gnarly, well-seasoned voice rings with hard-won authenticity and wisdom, ideal for historical epics, gritty westerns, and stories demanding a road-worn raconteur. Hewn from decades of hard-lived adventures, his timbre captivates with a richly textured tapestry of human experience. Immerse yourself in the soulful perseverance and existential gravitas evoked by his masterfully aged, craggy vocals.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/uVKHymY7OYMd6OailpG5/tsTVrF3jtTNLBCzAPIxD.mp3',
    isNarrator: false,
    category: 'Narrators',
    gender: 'male'
  },
  {
    id: 'NZiuR1C6kVMSWHG27sIM',
    name: 'Noushin',
    description: 'A warm, lyrical female voice with a Persian (Farsi) accent, carrying a gentle rhythm and a touch of elegance. Though classified under a nearby regional accent, it features unique Persian intonations — ideal for storytelling, conversational narration, and emotional content.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/trk65esPwHW9egX9hfLL1m6xPzQ2/voices/NZiuR1C6kVMSWHG27sIM/4CD8RFZY5GU4sBQjBDqV.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'female'
  },
  {
    id: '54Cze5LrTSyLgbO6Fhlc',
    name: 'Cat - Droll and Dry',
    description: 'Perfect for animation or audiobooks, the vibe of this voice is "whatever." Sarcastic, droll, and dry, she\'ll entertain you with her wry humor and a side eye. She\'d rather be watching paint dry or counting ceiling tiles. If you\'re looking for sunshine and rainbows, you\'ve come to the wrong place—try again next Tuesday.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/QGJ6kZIcVVcDLrmVSXsU5Sau0ei1/voices/54Cze5LrTSyLgbO6Fhlc/0qOKD9m3RsKKNnf4rpWV.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'female'
  },
  {
    id: 'si0svtk05vPEuvwAW93c',
    name: 'Blondie - Intense Woman',
    description: 'Powerful British female voice with dramatic flair—ideal for strong characters and bold messages.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/Gjq8tifaacbkhmUOdXIosinb17z2/voices/si0svtk05vPEuvwAW93c/TkB6WbetUaykJ1KWBvNB.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'female'
  },
  {
    id: 'MiueK1FXuZTCItgbQwPu',
    name: 'Maya - Young Australian Female',
    description: 'A young Australian female voice. Perfect for narration and character voice over. ',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/MiueK1FXuZTCItgbQwPu/dY0JGbhvAH2WTEuoj9Bu.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'female'
  },
  {
    id: 'eVItLK1UvXctxuaRV2Oq',
    name: 'Female Villain Voice',
    description: 'A seductive and dangerous femme fatale, this female voice drips with the allure of a villain. Perfect for video game characters. Think "over the top, exaggerated, anime villain" voice!',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/eVItLK1UvXctxuaRV2Oq/CHtqtnSGvzxCBQyDa6m9.mp3',
    isNarrator: false,
    category: 'Villains',
    gender: 'female'
  },
  {
    id: 'FF7KdobWPaiR0vkcALHF',
    name: 'David - Epic Movie Trailer',
    description: 'Middle aged Male with a deep voice. Suitable for Entertainment & TV.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/FF7KdobWPaiR0vkcALHF/M0VmTmIFXsie1kg33XBh.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'male'
  },
  {
    id: 'qNkzaJoHLLdpvgh5tISm',
    name: 'Carter the Mountain King',
    description: 'Middle-aged American male. Voice is rich, smooth, & rugged. Each syllable lingers on the palate, leaving a tantalizing trail of sensation in its wake. Deep and sonorous, this Voice of the Mountain resonates... sending vibrations that stir the senses and beckon you closer, promising secrets and fulfilling them.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/qNkzaJoHLLdpvgh5tISm/N0JJBx37oVjY5Juzh0QY.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'male'
  },
  {
    id: 'oR4uRy4fHDUGGISL0Rev',
    name: 'Myrddin - Magical Narrator & Wise Mentor',
    description: 'Myrddin: The definitive (800+ years old) wizard voice for any true magical narration. This mystic sage combines commanding magical authority with twinkling wisdom and warmth. Perfect for audiobooks, RPG characters, video games, and mystical narration, Myrddin\'s voice ranges from thunderous proclamations to whispered secrets, delivering authentic magical gravitas. His voice carries centuries of knowledge and gentle warmth of a wise mentor, delivering authentic magic for any fantasy project.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/aWnKUw0pyjYMNaT9LJ1L6nH5r693/voices/oR4uRy4fHDUGGISL0Rev/h3sx1GXkLl4PWogk0hfB.mp3',
    isNarrator: false,
    category: 'Fantasy',
    gender: 'male'
  },
  {
    id: 'UFO0Yv86wqRxAt1DmXUu',
    name: 'Mordred - Evil Villain Bösewicht',
    description: 'Perfect Villain Voice: Mordred\'s Voice is sultry, sarcastic, and mercurial. Shifts from purring sophistication to explosive rage. Masterful vocal manipulation—sultry, dangerous, unforgettably sinister. Perfect for complex antagonists, dark comedy, and "Bösewicht characters"!',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/aWnKUw0pyjYMNaT9LJ1L6nH5r693/voices/UFO0Yv86wqRxAt1DmXUu/mq94Rigji6wtvJGe0uJQ.mp3',
    isNarrator: false,
    category: 'Villains',
    gender: 'male'
  },
  {
    id: '0SpgpJ4D3MpHCiWdyTg3',
    name: 'Matthew Schmitz - Elitist, Arrogant, Conniving Tyrant',
    description: 'Arrogance and cold superiority, each word razor-sharp, deliberate, and steeped in condescension. There is a measured, venomous precision. An undercurrent of mockery, a subtle sneer woven into the cadence. Commanding, laced with menace, demands obedience. A man utterly convinced of his own supremacy. Voiced by Matthew Schmitz, a professional audiobook narrator with a large fan-base.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/Ebw6aIoLNBYbnP45ZSB5aHxmIAo2/voices/0SpgpJ4D3MpHCiWdyTg3/jeBADcJaT9DvZP2cOlpx.mp3',
    isNarrator: false,
    category: 'Villains',
    gender: 'male'
  },
  {
    id: 'pPdl9cQBQq4p6mRkZy2Z',
    name: 'Dr. Von Fusion VF - Quirky Mad Scientist',
    description: 'Energetic, quirky voice ideal for eccentric characters and inventive narration.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/anuOXXi5bHavgKk8o77RTVVQNYH2/voices/yjJ45q8TVCrtMhEKurxY/HxpTT1SCMFKlnCyqPwc5.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'male'
  },
  {
    id: 'vfaqCOvlrKi4Zp7C2IAm',
    name: 'Demon Monster',
    description: 'A Deep Demon Monster. Perfect for Video Games, Characters & Animation. Ghoul, Monster, Fantasy, Dark, Horror.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/vfaqCOvlrKi4Zp7C2IAm/mLg8Cp6Jq1r0xAbqjgwJ.mp3',
    isNarrator: false,
    category: 'Fantasy',
    gender: 'male'
  },
  {
    id: 'flHkNRp1BlvT73UL6gyz',
    name: 'Jessica Anne Bogart - Character and Animation',
    description: 'The Villain! Wickedly eloquent. Calculating. Cruel and calm.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/yA8yDNUx4dZ4gwL9ztbTpUEIyR12/voices/flHkNRp1BlvT73UL6gyz/Wi2FL0vNQp7bJAeSrJaz.mp3',
    isNarrator: false,
    category: 'Villains',
    gender: 'female'
  },
  {
    id: '9yzdeviXkFddZ4Oz8Mok',
    name: 'Lutz Laugh - Chuckling and Giggly',
    description: 'Young American male voice cheerfully cracking up. Perfect for humorous dialogues and happy characters. Voice was created reading jokes and funny literature.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/9yzdeviXkFddZ4Oz8Mok/uip7HIrjnhVsdCoqjtes.mp3',
    isNarrator: false,
    category: 'Characters',
    gender: 'male'
  },
  {
    id: '6sFKzaJr574YWVu4UuJF',
    name: 'Cornelius - Wise sage',
    description: 'A wise old sage wizard, with tales to spin for you!',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/6clvUi8d9vVBrcjHtTwgbRCin3w2/voices/6sFKzaJr574YWVu4UuJF/bae10fdc-1b77-4f60-a4d5-72e1a72736af.mp3',
    isNarrator: false,
    category: 'Fantasy',
    gender: 'male'
  },
  {
    id: 'piI8Kku0DcvcL6TTSeQt',
    name: 'Flicker - Cheerful Fairy & Sparkly Sweetness',
    description: 'Professional Fairy Voice - Flicker is a tiny, sweet fairy. She is cheerful, smart, and chatty. Perfect for Videogames, charming fairy characters or tiny elves, she will bring the special "spark" to your project!',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/lFNGNAk5YLffigappUfROhDCMur1/voices/piI8Kku0DcvcL6TTSeQt/cSTbbywSZ5O2WZn4xY3t.mp3',
    isNarrator: false,
    category: 'Fantasy',
    gender: 'female'
  },
  {
    id: 'Z3R5wn05IrDiVCyEkUrK',
    name: 'Arabella',
    description: 'A young, mature female narrator with a mysterious and emotive tone, perfect for fantasy, romance, urban fantasy, and wellness.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/vkjueGLSA9PX5LQZ86Iuq5jIWpr1/voices/Z3R5wn05IrDiVCyEkUrK/CBYKafo5onIe5234rAGS.mp3',
    isNarrator: true,
    category: 'Narrators',
    gender: 'female'
  },
  {
    id: 'uYkKk3J4lEp7IHQ8CLBi',
    name: 'Justin - Relaxed & Informative',
    description: 'Young American male with a Cool, calm and collected voice. Great for corporate videos and explainers.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/MTJGQeyNyoUXJvO9PZyfMN6vd583/voices/uYkKk3J4lEp7IHQ8CLBi/Peaj6szf0cgYopP8kh6U.mp3',
    isNarrator: true,
    category: 'Narrators',
    gender: 'male'
  },
  {
    id: 'UgBBYS2sOqTuMpoF3BR0',
    name: 'Mark - Natural Conversations',
    description: 'A casual, young-adult speaking in a natural manner. Perfect for Conversational AI.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/y7Wmp2r8nCeGkLiXiwMOVWktro13/voices/UgBBYS2sOqTuMpoF3BR0/0Oc7jiXwWN9kRTXfQsmw.mp3',
    isNarrator: true,
    category: 'Narrators',
    gender: 'male'
  },
  {
    id: 'yj30vwTGJxSHezdAGsv9',
    name: 'Jessa - Easygoing, conversational and real, with a best friend vibe ',
    description: 'A natural, effortless, and relatable female voice with a casual, off-the-cuff style that feels genuinely real.',
    sampleUrl: 'https://storage.googleapis.com/eleven-public-prod/database/user/5hdLTpEDbjeg4UK1vl9DvlAbJ4I2/voices/yj30vwTGJxSHezdAGsv9/WbcHry6vaoPISzfJJKRC.mp3',
    isNarrator: true,
    category: 'Narrators',
    gender: 'female'
  }
];

// Helper function to get a stock voice by ID
export const getStockVoiceById = (id) => {
  return stockVoices.find(voice => voice.id === id);
};

// Helper function to get the first stock voice (useful for auto-selection)
export const getFirstStockVoice = () => {
  return stockVoices.length > 0 ? stockVoices[0] : null;
}; 